/*
 * Copyright (C) Luna Srl - All Rights Reserved
 *
 * @project    bfree-frontend.nosync
 * @file       DeviceImage.tsx
 * @author     Christian Ascone
 * @date       9/19/19 7:14 PM
 */

import React from 'react';
import {Image} from "react-native";

export function DeviceImage(props) {
    return (
        <Image
            {...props}
            style={[props.style]}
            source={
                require('../../assets/images/device.png')
            }
        />
    );
}